<div class="buttons-container">
  <div class="base-buttons">
    <!-- Opens to the right: this is the first of the buttons, so there is only the title to its left -->
    <app-dropdown data-cy="download-dropdown" position="left">
      <mat-icon header>file_download</mat-icon>
      <ng-container body>
        <a
          (click)="downloadPng()"
          (keydown.enter)="downloadPng()"
          (keydown.space)="downloadPng()"
          data-cy="download-png"
          tabindex="0"
        >
          <mat-icon class="material-icons-outlined">image</mat-icon>
          <span>{{ 'DOWNLOAD.PNG' | translate }}</span>
        </a>
        <a
          (click)="downloadCsv()"
          (keydown.enter)="downloadCsv()"
          (keydown.space)="downloadCsv()"
          data-cy="download-csv"
          tabindex="0"
        >
          <mat-icon class="material-icons-outlined">text_snippet</mat-icon>
          <span>{{ 'DOWNLOAD.CSV' | translate }}</span>
        </a>
      </ng-container>
    </app-dropdown>

    <button
      data-cy="tooltip-zoom-out"
      mat-mini-fab
      class="accent-fab"
      (mousedown)="zoomPlot(false)"
      [matTooltip]="'TOOLTIP.ZOOM.OUT' | translate"
    >
      <mat-icon>zoom_out</mat-icon>
    </button>

    <button
      data-cy="tooltip-zoom-in"
      mat-mini-fab
      class="accent-fab"
      (mousedown)="zoomPlot(true)"
      [matTooltip]="'TOOLTIP.ZOOM.IN' | translate"
    >
      <mat-icon>zoom_in</mat-icon>
    </button>

    <button
      data-cy="tooltip-refresh"
      mat-mini-fab
      class="accent-fab"
      [disabled]="refreshButtonAvailable()"
      (mousedown)="refreshGraph()"
      [matTooltip]="'TOOLTIP.REFRESH' | translate"
    >
      <mat-icon>refresh</mat-icon>
    </button>

    <app-dropdown>
      <mat-icon header>settings</mat-icon>
      <ng-container body>
        @if (!isFullScreen) {
          <div
            (mousedown)="requestFullScreen()"
            data-cy="uplot-fullscreen"
            tabindex="0"
            (keydown.enter)="requestFullScreen()"
            (keydown.space)="requestFullScreen()"
          >
            <mat-icon class="material-icons-outlined">fullscreen</mat-icon>
            {{ 'UPLOT.FULLSCREEN' | translate }}
          </div>
        }

        <label data-cy="uplot-show-tooltip">
          <mat-icon class="material-icons-outlined">message</mat-icon>
          {{ 'UPLOT.SHOW_TOOLTIP' | translate }}
          <input type="checkbox" [(ngModel)]="uplotShowTooltip" id="tooltip" name="tooltip" />
        </label>

        @if (uplotShowTooltip) {
          <label style="padding-left: 20px" data-cy="uplot-show-tooltip-extended">
            <mat-icon class="material-icons-outlined">format_list_bulleted</mat-icon>
            {{ 'UPLOT.SHOW_TOOLTIP_EXTENDED' | translate }}
            <input
              type="checkbox"
              [(ngModel)]="uplotShowTooltipExt"
              id="extTooltip"
              name="extTooltip"
            />
          </label>
        }

        <label data-cy="uplot-series-fill">
          <mat-icon class="material-icons-outlined">area_chart</mat-icon>
          {{ 'UPLOT.SERIES_FILL' | translate }}
          <input type="checkbox" [(ngModel)]="seriesFilled" id="chartFill" name="chartFill" />
        </label>

        @if (isDevMode) {
          <label data-cy="uplot-log-scale">
            <mat-icon class="material-icons-outlined">query_stats</mat-icon>
            {{ 'UPLOT.LOG_SCALE' | translate }}
            <input type="checkbox" [(ngModel)]="isLogarithmicScale" id="logScale" name="logScale" />
          </label>
        }

        <label data-cy="uplot-show-avg">
          <mat-icon class="material-icons-outlined">functions</mat-icon>
          {{ 'UPLOT.SHOW_AVG' | translate }}
          <input type="checkbox" [(ngModel)]="uplotShowAvg" id="avg" name="avg" />
        </label>

        <label data-cy="uplot-show-min">
          <mat-icon class="material-icons-outlined">horizontal_rule</mat-icon>
          {{ 'UPLOT.SHOW_MIN' | translate }}
          <input type="checkbox" [(ngModel)]="uplotShowMin" id="min" name="min" />
        </label>

        <label data-cy="uplot-show-max">
          <mat-icon class="material-icons-outlined">horizontal_rule</mat-icon>
          {{ 'UPLOT.SHOW_MAX' | translate }}
          <input type="checkbox" [(ngModel)]="uplotShowMax" id="max" name="max" />
        </label>
      </ng-container>
    </app-dropdown>

    @if (isFullScreen) {
      <button
        data-cy="uplot-exit-fullscreen"
        mat-icon-button
        (mousedown)="exitFullScreen()"
        [matTooltip]="'UPLOT.EXIT_FULLSCREEN' | translate"
      >
        <mat-icon>close_fullscreen</mat-icon>
      </button>
    }
  </div>

  <div class="range-settings">
    <!--    <mat-select *ngIf="opts.showScaleSettings" [value]="opts.currentScale$.value"-->
    <!--      (selectionChange)="opts.currentScale$.next($event.value)" panelClass="mat-select-min-width-200">-->
    <!--      <mat-option *ngFor="let scaleType of scaleTypes" [value]="scaleType" [disabled]="!isScaleEnabled(scaleType)"-->
    <!--        >{{ getScaleString(scaleType) | translate }}-->
    <!--        <span-->
    <!--          *ngIf="scaleType === UplotScaleModes.AUTO && opts.currentScale$.value === UplotScaleModes.AUTO"-->
    <!--          >({{ getScaleString(getRealCurrentScale()) | translate }})</span-->
    <!--        >-->
    <!--      </mat-option>-->
    <!--    </mat-select>-->

    @if (opts.showCustomRangesSettings) {
      <mat-select
        [value]="opts.userDefinedRange$.value"
        (selectionChange)="opts.userDefinedRange$.next($event.value)"
        panelClass="mat-select-min-width-200"
      >
        @for (definedRange of definedRanges; track definedRange; let i = $index) {
          <mat-option [disabled]="i === 0" [value]="definedRange"
            >{{ getRangeString(definedRange) | translate }}
          </mat-option>
        }
      </mat-select>
    }
  </div>

  <ng-content></ng-content>
</div>
